// frontend/src/components/EdaAnalysis/EdaTargetDistribution.tsx

import React from 'react';

interface Props {
  analysis: any;
}

const renderValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const EdaTargetDistribution: React.FC<Props> = ({ analysis }) => {
  const targetDist = analysis?.target_distribution;
  const distributionEntries = targetDist && typeof targetDist === 'object' && !Array.isArray(targetDist)
    ? Object.entries(targetDist)
    : [];

  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
      borderRadius: '12px',
      padding: '20px',
      border: '1px solid #1a4a7a',
      marginBottom: '24px',
    }}>
      <h3 style={{ color: '#4fc3f7', margin: '0 0 16px 0' }}>
        🎯 O que Queremos Prever: {renderValue(analysis?.target_name)}
      </h3>

      {/* CAMADA 1: RESUMO DE NEGÓCIO */}
      <div style={{
        background: 'rgba(79, 195, 247, 0.08)',
        borderLeft: '3px solid #4fc3f7',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '20px',
        color: '#e0e0e0',
        fontSize: '14px',
        lineHeight: 1.6,
      }}>
        <p style={{ margin: '0 0 8px 0' }}>
          💡 <strong style={{ color: '#4fc3f7' }}>O que isso significa:</strong>
        </p>
        <p style={{ margin: 0 }}>
          Estamos analisando a distribuição da coluna <strong>{renderValue(analysis?.target_name)}</strong>. 
          A tabela abaixo mostra quantas vezes cada valor aparece no seu dataset.
          {analysis?.majority_class_ratio !== undefined && (
            <> A proporção da classe mais comum é de <strong>{renderValue(analysis.majority_class_ratio)}</strong>.</>
          )}
        </p>
      </div>

      {/* CAMADA 2: TABELA TÉCNICA */}
      {distributionEntries.length > 0 && (
        <div style={{ overflowX: 'auto', background: 'rgba(10, 10, 26, 0.4)', borderRadius: '8px', padding: '12px' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', color: '#ffffff' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid #1a4a7a' }}>
                <th style={{ textAlign: 'left', padding: '8px', color: '#8899aa', fontWeight: 500 }}>Classe / Valor</th>
                <th style={{ textAlign: 'left', padding: '8px', color: '#8899aa', fontWeight: 500 }}>Proporção</th>
              </tr>
            </thead>
            <tbody>
              {distributionEntries.map(([key, value]) => (
                <tr key={key} style={{ borderBottom: '1px solid #16213e' }}>
                  <td style={{ padding: '8px' }}>{key}</td>
                  <td style={{ padding: '8px' }}>{renderValue(value)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};